// Legacy singing posts are retired from the feed (2026-08-02).
//
// `mediaType='song'` holds 12,145 recordings from the old FreeStyle recorder,
// none newer than 2026-02-03. The recorder is gone; the rows stay in the DB but
// no longer render. New karaoke covers use `mediaType='cover'` precisely so they
// are not caught by this filter.
const RETIRED_MEDIA_TYPES = ['song'];

export function isRetiredPost(post) {
  return !!post && RETIRED_MEDIA_TYPES.includes(post.mediaType);
}

// Rows come back from getResult in two shapes: `CALL sp_x()` yields
// [[rows], okPacket] while a plain SELECT yields [rows]. Callers here always
// pass the already-unwrapped row array, so just guard for non-arrays.
export function withoutRetiredPosts(rows) {
  if (!Array.isArray(rows)) return rows;
  return rows.filter((row) => !isRetiredPost(row));
}

export default withoutRetiredPosts;
